import { type Control, useForm, useWatch } from 'react-hook-form';
import { Card } from '@/components/ui/card';
import { DataTable } from '@/components/ui/data-table';
import { layoutToColumns, ScreenForm } from '@/lib/screen-renderer';

export function ScreenPreview({ control }: { control: Control<any> }) {
  const layout = useWatch({ control, name: 'layout' });
  const resource = useWatch({ control, name: 'resource' });
  const previewForm = useForm<Record<string, any>>({ defaultValues: {} });

  const columns = layoutToColumns(layout?.columns ?? [], resource ?? '');

  return (
    <div className="space-y-6 col-span-12">
      <Card className="p-4">
        <h3 className="font-semibold mb-3">Preview da listagem</h3>
        <DataTable columns={columns} data={[]} />
      </Card>

      <Card className="p-4">
        <h3 className="font-semibold mb-3">Preview do formulário</h3>
        <div className="grid grid-cols-12 gap-4">
          <ScreenForm
            fields={layout?.fields ?? []}
            control={previewForm.control}
            mode="create"
          />
        </div>
      </Card>
    </div>
  );
}
